import { createContext, useCallback, useContext, useState } from 'react'
import { Snackbar, Alert } from '@mui/material'

const NotifyContext = createContext(null)

// Equivalente al servicio `notify` de Qualita: toasts de éxito/error/info.
export function NotificationProvider({ children }) {
  const [snack, setSnack] = useState({ open: false, message: '', severity: 'info' })

  const notify = useCallback((message, severity = 'info') => {
    setSnack({ open: true, message, severity })
  }, [])

  const value = {
    success: (m) => notify(m, 'success'),
    error: (m) => notify(m, 'error'),
    info: (m) => notify(m, 'info'),
    warning: (m) => notify(m, 'warning'),
  }

  return (
    <NotifyContext.Provider value={value}>
      {children}
      <Snackbar
        open={snack.open}
        autoHideDuration={5000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          severity={snack.severity}
          variant="filled"
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          sx={{ width: '100%' }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </NotifyContext.Provider>
  )
}

export function useNotify() {
  const ctx = useContext(NotifyContext)
  if (!ctx) throw new Error('useNotify debe usarse dentro de <NotificationProvider>')
  return ctx
}
